import { Injectable } from '@angular/core';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Injectable({
  providedIn: 'root'
})
export class GtmService {

  constructor() { }

  public pushDataToDataLayer(data: any) {
    if (typeof window !== 'undefined' && window['dataLayer']) {
      // Push data to the data layer
      window['dataLayer'].push(data);
    } else {
      // Handle the case where the dataLayer is not defined
      console.error('Data layer not found. Make sure Google Tag Manager is set up correctly.');
    }
  }

}
